/**
 * Whether this is an Apple platform, where the command key is the shortcut modifier (⌘↵), not Control.
 * Reads `navigator.userAgentData.platform` where the browser has it, else `navigator.platform` (deprecated but
 * universal), else the user agent. Anything unknown counts as not Apple, so the hint says Ctrl.
 */
export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
  const platform = uaData?.platform || navigator.platform || navigator.userAgent || '';
  return /mac|iphone|ipad|ipod/i.test(platform);
}
